(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
  // Collapsible functionality
  const collapsibleTriggers = document.querySelectorAll('.collapsible-trigger');
  
  collapsibleTriggers.forEach(trigger => {
    // Set initial state
    const isOpen = trigger.classList.contains('is-open');
    trigger.setAttribute('aria-expanded', isOpen);
    
    // Add click event
    trigger.addEventListener('click', toggleCollapsible);
  });
  
  function toggleCollapsible(e) {
    const trigger = e.currentTarget;
    const isOpen = trigger.classList.contains('is-open');
    const moduleId = trigger.getAttribute('aria-controls');
    const container = document.getElementById(moduleId);
    
    if (!container) return;
    
    const contentInner = container.querySelector('.collapsible-content__inner');
    const isAutoHeight = container.classList.contains('collapsible--auto-height');
    
    // Toggle aria-expanded
    trigger.setAttribute('aria-expanded', !isOpen);
    
    // Toggle classes
    if (isOpen) {
      trigger.classList.remove('is-open');
      container.classList.remove('is-open');
      
      // If auto-height, set height to 0 for closing animation
      if (isAutoHeight) {
        container.style.height = contentInner.offsetHeight + 'px';
        // Force reflow
        container.offsetHeight;
        container.style.height = '0px';
      } else {
        container.style.height = '0px';
      }
    } else {
      trigger.classList.add('is-open');
      container.classList.add('is-open');
      
      // If auto-height, set to actual height then auto
      if (isAutoHeight) {
        container.style.height = contentInner.offsetHeight + 'px';
        setTimeout(() => {
          container.style.height = 'auto';
        }, 300);
      } else {
        container.style.height = contentInner.offsetHeight + 'px';
      }
    }
    
    // Add transition end listener for auto-height containers
    if (isAutoHeight) {
      const handleTransitionEnd = () => {
        if (container.classList.contains('is-open')) {
          container.style.height = 'auto';
        }
        container.removeEventListener('transitionend', handleTransitionEnd);
      };
      
      container.addEventListener('transitionend', handleTransitionEnd);
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
